// extracted by mini-css-extract-plugin
module.exports = {"resume":"style_resume__1XIDB","leftSide":"style_leftSide__2fWqJ","rightSide":"style_rightSide__2lEJ0"};